import { useApp } from "../app/AppContext.jsx";

/** Compact pager: first, a window around the current page, last. */
export default function Pagination({ page, pages, onChange }) {
  const { t } = useApp();
  if (pages <= 1) return null;

  const window = 2;
  const nums = [];
  for (let i = 1; i <= pages; i++) {
    if (i === 1 || i === pages || (i >= page - window && i <= page + window)) nums.push(i);
    else if (nums[nums.length - 1] !== "…") nums.push("…");
  }

  return (
    <nav className="pagination" aria-label="Pagination">
      <button aria-label={t("common.previous")} onClick={() => onChange(page - 1)} disabled={page <= 1}>‹</button>
      {nums.map((n, i) =>
        n === "…" ? (
          <span key={`gap${i}`} className="muted" style={{ padding: "0 4px" }}>…</span>
        ) : (
          <button key={n} className={n === page ? "is-active" : undefined} onClick={() => onChange(n)} aria-current={n === page ? "page" : undefined}>
            {n}
          </button>
        )
      )}
      <button aria-label={t("common.next")} onClick={() => onChange(page + 1)} disabled={page >= pages}>›</button>
    </nav>
  );
}
